
import React from 'react';
import { useLanguage } from '@/context/LanguageContext';
import { Button } from '@/components/ui/button';
import { ExternalLink } from 'lucide-react';

const RadexHero = () => {
  const { t } = useLanguage();

  return (
    <section className="relative py-20 md:py-32 overflow-hidden">
      {/* Background with overlay */}
      <div 
        className="absolute inset-0 bg-cover bg-center z-0" 
        style={{ 
          backgroundImage: "url('/background_images/radex_hero.jpg')",
        }}
      >
        <div className="absolute inset-0 bg-gray-900/80"></div>
      </div>
      
      <div className="container mx-auto px-4 relative z-10">
        <div className="flex flex-col md:flex-row items-center justify-between gap-10">
          <div className="w-full md:w-1/2">
            <div className="h-20 mb-8 flex items-center">
              <img 
                src="/RM_logo-W.png" 
                alt="Radex Markets Logo" 
                className="h-full w-auto object-contain" 
              />
            </div>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-6">
              {t('radex.hero.title') || "The Club & Radex Markets Partnership"}
            </h1>
            <p className="text-xl md:text-2xl text-gray-300 mb-8">
              {t('radex.hero.subtitle') || "Unleash exceptional trading opportunities through our strategic partnership"}
            </p>
            <div className="flex flex-wrap gap-4">
              <Button 
                size="lg"
                className="bg-transparent border-2 border-purple-500 text-purple-400 hover:bg-purple-500/10 px-8 py-2.5 rounded-full text-base font-medium shadow-lg hover:shadow-xl transition-all"
                asChild
              >
                <a 
                  href="https://www.radexmarkets.com/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="flex items-center gap-2"
                >
                  <span>{t('radex.hero.visitWebsite') || "Visit Website"}</span>
                  <ExternalLink size={16} />
                </a>
              </Button>
            </div>
          </div>
          
          <div className="w-full md:w-1/2 flex justify-center">
            <div className="bg-gray-800/70 backdrop-blur-sm p-8 rounded-lg border border-gray-700 shadow-xl">
              <h3 className="text-2xl font-bold text-white mb-4">{t('radex.hero.partnership') || "Exclusive Investment Opportunities"}</h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-2">
                  <div className="rounded-full bg-purple-500/20 p-1 mt-1">
                    <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                  </div>
                  <p className="text-gray-300">{t('radex.hero.benefit1') || "Licensed & Regulated Broker"}</p>
                </li>
                <li className="flex items-start gap-2">
                  <div className="rounded-full bg-purple-500/20 p-1 mt-1">
                    <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                  </div>
                  <p className="text-gray-300">{t('radex.hero.benefit2') || "Cutting-edge Trading Technology"}</p>
                </li>
                <li className="flex items-start gap-2">
                  <div className="rounded-full bg-purple-500/20 p-1 mt-1">
                    <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                  </div>
                  <p className="text-gray-300">{t('radex.hero.benefit3') || "Advanced Security Protocols"}</p>
                </li>
                <li className="flex items-start gap-2">
                  <div className="rounded-full bg-purple-500/20 p-1 mt-1">
                    <div className="w-2 h-2 rounded-full bg-purple-500"></div>
                  </div>
                  <p className="text-gray-300">{t('radex.hero.benefit4') || "Exclusive Club Member Benefits"}</p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RadexHero;
